<template>
  <div class="mx-10 ma-5">
    <v-card flat class="pa-5">
      <div>
        <PageTitleWithSearch
          :title="'Other Income Entries'"
          :btnName="'Create New Income Entry'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/other-income/entries/create'"
          :btnPermission="'income_entries.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />
        <DataTableWithPagination
          :headers="tableHeaders"
          :items="incomeEntryList"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="onPageChange"
          dense
        >
          <template #row="{ item, index }">
            <tr
              :key="item.uuid"
              :class="[
                { 'first-row': index === 0 },
                index % 2 === 0 ? 'dark-row' : 'light-row',
                'custom-row',
              ]"
            >
              <td class="text-left">{{ item.income_type_name }}</td>
              <td class="text-left">
                {{ formatDate(item.date_of_income, dateFormat) }}
              </td>
              <td class="text-left">{{ item.payer_source }}</td>
              <td class="text-left">{{ item.description }}</td>
              <td class="text-left">{{ item.payment_method }}</td>
              <td class="text-right">{{ item.amount }}</td>
              <!-- <td class="text-left">
                <v-btn
                  class="ma-1"
                  color="#FFE0B2"
                  :to="'/other-income/entries/edit/' + item.uuid"
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-pencil</v-icon>
                </v-btn>
              </td> -->
            </tr>
          </template>
        </DataTableWithPagination>
      </div>
    </v-card>
  </div>
</template>

<script>
import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import { OtherIncomeService } from "@/services/otherIncome-service.js";
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import { useDateFormatter } from "@/composables/useDateFormatter";
import { mapGetters as rootMapGetters } from "vuex";

export default {
  name: "OtherIncomeList",
  components: {
    PageTitleWithSearch,
    DataTableWithPagination,
  },
  data() {
    return {
      loading: false,
      confirmOpen: false,
      dropId: null,
      snackbar: false,
      search: "",
      incomeEntryList: [],
      headers: [
        { text: "Income Type", align: "left", value: "income_type_name" },
        { text: "Date", align: "left", value: "date_of_income" },
        { text: "Payer/Source", align: "left", value: "payer_source" },
        { text: "Description", align: "left", value: "description" },
        { text: "Payment Method", align: "left", value: "payment_method" },
        { text: "Amount", align: "center", value: "amount", isCurrency: true },
        // { text: "Actions", align: "left", value: "actions" },
      ],
      page: 1,
      total: 0,
      ...useDateFormatter(),
    };
  },
  computed: {
    ...rootMapGetters("settings", ["dateFormat", "currencyCode"]),
    tableHeaders() {
      return this.headers.map((h) => {
        if (h.isCurrency) {
          return {
            ...h,
            text: `${h.text} (${this.currencyCode})`, // Add currency code automatically
          };
        }
        return h;
      });
    },
  },
  created() {
    this.fetchIncomeList();
  },
  watch: {
    search() {
      this.page = 1;
      this.fetchIncomeList();
    },
    page() {
      this.fetchIncomeList();
    },
  },
  methods: {
    async fetchIncomeList() {
      this.loading = true;
      try {
        const response = await OtherIncomeService.getIncomeEntriesList(
          this.search,
          this.page
        );

        this.incomeEntryList = response?.data.data || [];
        this.total = response.data.meta.last_page || 0;
      } catch (error) {
        this.incomeEntryList = [];
        this.total = 0;
        console.error("Error fetching Income List:", error);
      } finally {
        this.loading = false;
      }
    },
    onPageChange(newPage) {
      this.page = newPage;
    },
    searchChange(event) {
      this.search = event;
    },
    closeSnackbar() {
      this.snackbar = false;
    },
  },
};
</script>
